import { render, staticRenderFns } from "./KnowledgeBase.html?vue&type=template&id=912ff504&scoped=true&external"
import script from "./KnowledgeBase.vue?vue&type=script&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBase.scss?vue&type=style&index=0&id=912ff504&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912ff504",
  null
  
)

export default component.exports